"use client";

import clsx from "clsx";
import type React from "react";
import { createContext, useContext } from "react";
import Typography from "src/components/common/Typography/Typography";

interface PortalPageHeaderContextValue {
  sticky: boolean;
}

const PortalPageHeaderContext = createContext<PortalPageHeaderContextValue>({ sticky: false });

export const PortalPageHeaderProvider = (props: {
  sticky: boolean;
  children?: React.ReactNode;
}) => (
  <PortalPageHeaderContext.Provider value={{ sticky: props.sticky }}>
    {props.children}
  </PortalPageHeaderContext.Provider>
);

export interface PortalPageTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

/** The page's only `h1`. Truncates with a tooltip while the header is sticky. */
export const PortalPageTitle = (props: PortalPageTitleProps) => {
  const { children, className, title, ...otherProps } = props;
  const { sticky } = useContext(PortalPageHeaderContext);

  return (
    <Typography
      as="h1"
      variant="heading2"
      tone="foreground"
      className={clsx("calmlens-portal-title", className)}
      truncate={sticky}
      title={title ?? (sticky && typeof children === "string" ? children : undefined)}
      {...otherProps}
    >
      {children}
    </Typography>
  );
};
